import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Writebacks'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Writebacks',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/writebacks',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
